/* eslint-disable no-undef */

document.addEventListener('DOMContentLoaded', () => {
  const script = document.createElement('script');
  script.src = 'https://securepubads.g.doubleclick.net/tag/js/gpt.js';
  script.async = true;
  script.onload = function () {
    loadAds(); // wordt gegarandeerd pas uitgevoerd na laden
  };
  document.head.appendChild(script);
});

window.googletag = window.googletag || { cmd: [] };

function loadAds() {
  const mainAd = 'ctmag';

  const topArray = ['/single.php', '/home.php', '/archive.php'];
  const mid1Array = ['/single.php'];
  const mid2Array = ['/single.php'];
  // const mid3Array = ['/single.php'];
  const isDetailPage = window.currentTemplate.includes('/single') ? '/detail' : '';

  const { isHomePage } = window;

  // Wait for googletag to be fully initialized
  googletag.cmd.push(() => {
    // Ensure googletag is properly initialized
    if (typeof googletag.sizeMapping !== 'function') {
      /* eslint-disable no-console */
      console.error('googletag.sizeMapping is not available');
      return;
    }

    const mappingBillboard = googletag.sizeMapping()
      .addSize([1200, 0], [[970, 250], [728, 90]])
      .addSize([0, 0], [])
      .build();

    const mappingRectangle = googletag.sizeMapping()
      .addSize([1200, 0], [[300, 600], [300, 250]])
      .addSize([728, 0], [[728, 90], [300, 250], [320, 240], [336, 280], 'fluid'])
      .addSize([320, 0], [])
      .build();

    const mappingRectangleMobile = googletag.sizeMapping()
      .addSize([1200, 0], [])
      .addSize([728, 0], [[320, 240], [300, 250], [480, 640]])
      .addSize([320, 0], [[320, 240], [300, 250]])
      .build();

    // If is homepage
    if (isHomePage) {
      googletag.defineSlot(`/${window.dfpID}/${mainAd}/homepage`, [[970, 250], [728, 90]], 'top')
        .setTargeting('pos', ['top'])
        .defineSizeMapping(mappingBillboard)
        .addService(googletag.pubads());

      googletag.defineSlot(`/${window.dfpID}/${mainAd}/homepage`, [[320, 240], [300, 250], [480, 640]], 'top_mobile')
        .setTargeting('pos', ['top'])
        .defineSizeMapping(mappingRectangleMobile)
        .addService(googletag.pubads());
    }

    // Function to initialize ads after GPT is loaded
    if (!isHomePage && topArray.includes(window.currentTemplate)) {
      googletag.defineSlot(`/${window.dfpID}/${mainAd}/${window.postType}${isDetailPage}`, [[970, 250], [728, 90]], 'top')
        .setTargeting('pos', ['top'])
        .defineSizeMapping(mappingBillboard)
        .addService(googletag.pubads());

      googletag.defineSlot(`/${window.dfpID}/${mainAd}/${window.postType}${isDetailPage}`, [[320, 240], [300, 250], [480, 640]], 'top_mobile')
        .setTargeting('pos', ['top'])
        .defineSizeMapping(mappingRectangleMobile)
        .addService(googletag.pubads());
    }

    if (!isHomePage && mid1Array.includes(window.currentTemplate)) {
      googletag.defineSlot(`/${window.dfpID}/${mainAd}/${window.postType}${isDetailPage}`, [[320, 240], [320, 100], [300, 250], [480, 640], [728, 90], [336, 280], [300, 600], 'fluid'], 'mid1')
        .setTargeting('pos', ['mid1'])
        .defineSizeMapping(mappingRectangle)
        .addService(googletag.pubads());
    }

    if (!isHomePage && mid2Array.includes(window.currentTemplate)) {
      googletag.defineSlot(`/${window.dfpID}/${mainAd}/${window.postType}${isDetailPage}`, [[320, 240], [320, 100], [300, 250], [480, 640], [728, 90], [336, 280], [300, 600]], 'mid2')
        .setTargeting('pos', ['mid2'])
        .defineSizeMapping(mappingRectangle)
        .addService(googletag.pubads());
    }

    if (window.currentTemplate === '/single.php') {
      googletag.pubads().setTargeting('tags', window.adTargeting?.tags ?? []);
    }

    googletag.pubads().enableSingleRequest();
    if (isDetailPage) {
      googletag.pubads().setTargeting('pagetype', ['detail']);
    }

    if (isHomePage) {
      googletag.pubads().setTargeting('pagetype', ['homepage']);
    }

    googletag.pubads().collapseEmptyDivs();
    googletag.pubads().setCentering(true);
    googletag.enableServices();

    if (((isHomePage) || topArray.includes(window.currentTemplate)) && document.getElementById('top')) {
      googletag.display('top');

      if (document.getElementById('top_mobile')) {
        googletag.display('top_mobile');
      }
    }

    if (mid1Array.includes(window.currentTemplate) && document.getElementById('mid1')) {
      googletag.display('mid1');
    }

    if (mid2Array.includes(window.currentTemplate) && document.getElementById('mid2')) {
      googletag.display('mid2');
    }

    // if (mid3Array.includes(window.currentTemplate) && document.getElementById('mid3')) {
    //   googletag.display('mid3');
    // }
  });

  /* eslint-enable no-undef */
}
